import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getSiteConfiguration } from '../../features/Configuration/configurationAction';
import DashboardCards from '../../components/DashboardCard/DashboardCards';
import { useDashboardHealthScore } from './useDashboardHealthScore';
import { DashboardHealthScoreCard } from '../../modules/DashboardHealthScore';

export function DashboardHealthScore({ title, refresh, type }) {
  const {
    riskRows,
    accountNum,
    loading,
    error,
    expiredRows,
    expiredAccountNum,
    expiredInMonths,
    threeMonthsLater,
    currentDate,
    riskAccountsColumnInfo,
    expiredAccountColumnInfo,
    decliningAccountColumnInfo,
    trendAccountColumnInfo,
    decliningRows,
    trendRows,
    decliningNum,
    trendAccountNum,
    loadingState,
    setLoadingState,
  } = useDashboardHealthScore();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const siteConfiguration = useSelector((state) => state.siteConfiguration?.data);

  useEffect(() => {
    dispatch(getSiteConfiguration());
    setLoadingState(true);
  }, []);

  const accountFilter = {
    riskAccounts: {
      count: `${accountNum} accounts`,
      subHeading: siteConfiguration?.highRiskAccountConfig?.metric?.name ?? 'Accounts with the Score 0 - 30',
      filters: {
        filters: {
          licenceStatus: ['Active'],
          accountVisibility: true,
          condition: siteConfiguration?.highRiskAccountConfig?.condition ?? 'healthScore <= 30',
        },
      },
      columns: riskAccountsColumnInfo,
      rows: riskRows,
    },
    expiredAccounts: {
      count: `${expiredAccountNum} accounts`,
      subHeading: `Accounts expiring in ${expiredInMonths} months`,
      filters: {
        filters: {
          renewalDate: {
            type: 'absolute',
            startDate: currentDate,
            endDate: threeMonthsLater,
          },
          licenceStatus: ['Active'],
          accountVisibility: true,
        },
        showAdvanceFilter: true,
      },
      columns: expiredAccountColumnInfo,
      rows: expiredRows,
    },
    decliningAccounts: {
      count: `${decliningNum} accounts`,
      filters: {
        filters: {
          healthScoreTrend: ['falling'], licenceStatus: ['Active'], accountVisibility: true,
        },
        showAdvanceFilter: true,
      },
      columns: decliningAccountColumnInfo,
      rows: decliningRows,
    },
    trendingAccounts: {
      count: `${trendAccountNum} accounts`,
      filters: {
        filters: {
          healthScoreTrend: ['rising'], licenceStatus: ['Active'], accountVisibility: true,
        },
        showAdvanceFilter: true,
      },
      columns: trendAccountColumnInfo,
      rows: trendRows,
    },
  };

  const handleNavigation = () => {
    navigate('/account-list', {
      state: accountFilter[type]?.filters,
    });
  };

  const handleTitleClick = () => {
    navigate('/configuration#high-risk-config');
  };

  return (
    <DashboardCards
      title={title}
      count={accountFilter[type]?.count}
      subHeading={accountFilter[type]?.subHeading}
      showButton
      buttonText="More"
      onClick={handleNavigation}
      onClickTitle={type === 'riskAccounts' && handleTitleClick}
    >
      <DashboardHealthScoreCard
        message="No Rows"
        loading={loading || loadingState}
        error={error}
        refresh={refresh}
        data={accountFilter[type]?.rows}
        columns={accountFilter[type]?.columns}
        rows={accountFilter[type]?.rows}
      />
    </DashboardCards>
  );
}
